import './ORDH.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class ORDH extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
